import { RootScopeEvents } from '../root-scope-types';
import { EndCallReasons } from '../doxy-analytics/tracks/video-session-end';
import * as dokbot from '../../../modules/dokbot';
const SKIP_SURVEY_REASONS = new Set([
    EndCallReasons.PAUSED,
    EndCallReasons.RESTARTED,
    EndCallReasons.RESTART_FROM_SETTINGS,
    EndCallReasons.RESTART_FROM_PARTICIPANT_ERROR,
    EndCallReasons.RESTART_FOR_GROUP,
    EndCallReasons.RESTART_FOR_AUDIO_TYPE,
]);
export class PatientSurveyLauncher {
    constructor($rootScope, dokbotPatientSurveyService, $ngRedux) {
        this.$rootScope = $rootScope;
        this.dokbotPatientSurveyService = dokbotPatientSurveyService;
        this.$ngRedux = $ngRedux;
    }
    init() {
        let isHold = false;
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.JOIN_SESSION_SUCCESS, () => {
            isHold = false;
            this.dokbotPatientSurveyService.closeSurvey();
        });
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.END_REASON, (_e, reason) => {
            isHold = Boolean(SKIP_SURVEY_REASONS.has(reason));
        });
        const unlisten = this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.SESSION_DISCONNECTED, () => {
            if (!isHold) {
                unlisten();
                const { patientSurveyId, isDokbotExtensionInstalled, patientSurveyFrequency, } = dokbot.selectors.getWorkflow(this.$ngRedux.getState());
                if (Boolean(isDokbotExtensionInstalled) && Boolean(patientSurveyId)) {
                    dokbot.initialiser.launchDelayedOneIn(patientSurveyFrequency || 10);
                    return;
                }
                this.dokbotPatientSurveyService.launchDelayedOneIn({
                    oneInNumber: 10,
                });
            }
        });
    }
}
